require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-pamhagen.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-pamhagen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-pamhagen!./.cache/json/betreuungseinrichtungen-neusiedl-pamhagen.json
// module id = 960
// module chunks = 231608221292675